import React, { createContext } from "react";
import PropTypes from "prop-types";
import EMPModal from "./EMPModal";
import useModal from "./useModal";

const ModalContext = createContext();
const { Provider } = ModalContext;

const ModalProvider = ({ children }) => {
  const { openModal, handleModal, closeModal, modalContent, modalHeading } =
    useModal();

  return (
    <Provider
      value={{
        openModal,
        handleModal,
        closeModal,
        modalContent,
        modalHeading,
      }}
    >
      <EMPModal />
      {children}
    </Provider>
  );
};

ModalProvider.propTypes = {
  children: PropTypes.node,
};

export { ModalContext, ModalProvider };
